module.exports = __webpack_public_path__ + "img/rate_full.bf3bf9c5.png";